import { useId, useState } from "react";
import { Button, Field, Modal } from "../../components";
import styles from "./Feuilles.module.css";

export type RefusFeuilleModalProps = {
  open: boolean;
  pending: boolean;
  /** Le refus du serveur sur la dernière tentative, déjà mis en mots. */
  erreur: string | null;
  onConfirm: (motif: string) => void;
  onCancel: () => void;
};

/**
 * Le motif d'un refus. Obligatoire : le consultant doit savoir quoi corriger,
 * et le serveur l'exige de toute façon. Le champ garde ce qu'on a tapé si le
 * serveur refuse — retaper un motif après un hoquet réseau serait cruel.
 */
export function RefusFeuilleModal({ open, pending, erreur, onConfirm, onCancel }: RefusFeuilleModalProps) {
  const [motif, setMotif] = useState("");
  const [touche, setTouche] = useState(false);
  const idAide = useId();
  const vide = motif.trim() === "";

  function confirmer() {
    setTouche(true);
    if (vide) {
      return;
    }
    onConfirm(motif.trim());
  }

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="Refuser cette feuille"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={pending}>
            Annuler
          </Button>
          <Button variant="danger" onClick={confirmer} loading={pending}>
            Refuser et renvoyer au consultant
          </Button>
        </>
      }
    >
      <p id={idAide} className={styles.mention}>
        La feuille redevient modifiable par le consultant, qui verra ce motif. Rien n'est imputé.
      </p>
      <Field
        label="Motif"
        required
        error={touche && vide ? "Indiquez ce qui doit être corrigé." : (erreur ?? undefined)}
      >
        {(commande) => (
          <textarea
            {...commande}
            className={styles.champ}
            value={motif}
            maxLength={1000}
            aria-describedby={idAide}
            onChange={(e) => setMotif(e.target.value)}
            disabled={pending}
          />
        )}
      </Field>
    </Modal>
  );
}
